import clsx from 'clsx'
import { alertLink } from '~/components/Global/Interactions/Alert/Alert.css'
import {
  skippedRecipientContainer,
  skippedRecipientLine
} from '~/components/Scopes/Actions/Actions.css'
import type {
  RecipientDisplayItem,
  RecipientType
} from '~/domains/actions/types'
import { classicLink } from '~/styles/app.css'

type RecipientListProps = {
  recipients: RecipientDisplayItem[]
  onRemove?: (id: number, type: RecipientType) => void
  canRemove?: boolean
}

export const RecipientList = ({
  recipients,
  onRemove,
  canRemove = false
}: RecipientListProps) => (
  <div className={skippedRecipientContainer}>
    {recipients.map(({ id, type, label, href, secondaryText, removable }) => (
      <div key={`${type}-${id}`} className={skippedRecipientLine}>
        {href ? (
          <a
            className={clsx(classicLink)}
            target="_blank"
            href={href}
            rel="noopener"
          >
            {label}
          </a>
        ) : (
          <span>{label}</span>
        )}
        {secondaryText}
        {onRemove && canRemove && removable && (
          <span
            className={clsx(classicLink, alertLink)}
            onClick={(e) => {
              e.preventDefault()
              onRemove(id, type)
            }}
          >
            Retirer
          </span>
        )}
      </div>
    ))}
  </div>
)
